export default "__VITE_ASSET__6001b9fa__"